export const getCorrectVatPlaceholder = (placeholder: string | undefined): string | undefined => {
  switch (placeholder) {
    case 'AT':
      return 'ATU';
    case 'GR':
      return 'EL';
    default:
      return placeholder;
  }
};
